.caption {
  display: flex;
  align-items: baseline;
  gap: 6px;
  font-size: 0.72rem;
  color: var(--color-text-muted);
  line-height: 1.4;
  padding: 6px 10px 8px;
  background-color: var(--color-bg-card);
}

.captionText {
  flex: 1;
  min-width: 0;
}

.infoLink {
  text-decoration: none;
  cursor: pointer;
  flex-shrink: 0;
  color: var(--color-text-muted);
  line-height: 1;
  align-self: center;
  display: flex;
}

.infoIcon {
  width: 1rem;
  height: 1rem;
}

.infoLink:hover {
  opacity: 0.75;
}
